import { render, staticRenderFns } from "./TheFooterOther.vue?vue&type=template&id=3c2fb4e9&scoped=true&"
import script from "./TheFooterOther.vue?vue&type=script&lang=js&"
export * from "./TheFooterOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2fb4e9",
  null
  
)

export default component.exports